import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useCatalogLanguages } from '../data/subServicesStore';
import { langFlagUrl } from '../utils/langFlags';
import assetUrl from '../assetUrl';
import './LanguagesPage.css';

export default function LanguagesPage() {
  const { t } = useLanguage();
  const p = t.languagesPage;
  const { languages: catalogLangs } = useCatalogLanguages();
  // Langues actives du catalogue (admin) — repli sur le contenu i18n hors-ligne
  const langs = catalogLangs.length
    ? catalogLangs.map((l) => ({ name: l.nameFr || l.code, flagUrl: langFlagUrl(l) }))
    : (p.languages || []).map((l) => ({ name: l.name, flagUrl: assetUrl(`/images/flags/${l.code}.svg`) }));

  return (
    <div className="languages-page">
      <header className="languages-page-hero">
        <img src="/images/earth-map.jpg" alt="" className="languages-page-hero-bg" aria-hidden="true" />
        <div className="languages-page-hero-glow" aria-hidden="true" />
        <div className="container languages-page-hero-inner">
          <h1>{p.title}</h1>
          <p>{p.subtitle}</p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="languages-page-grid">
            {langs.map((lang, i) => (
              <article
                key={lang.name}
                className="languages-page-card"
                style={{ '--lp-i': i }}
              >
                {lang.flagUrl ? (
                  <img
                    className="languages-page-flag"
                    src={lang.flagUrl}
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <span className="languages-page-flag" aria-hidden="true">🌐</span>
                )}
                <h2>{lang.name}</h2>
              </article>
            ))}
          </div>
        </div>

      </section>

      <div className="languages-page-note">
        <p>{p.note}</p>
        <div className="languages-page-actions">
          <Link to="/order" className="btn btn-primary">
            Commander en ligne
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            {p.contact}
          </Link>
        </div>
      </div>
    </div>
  );
}
